"use strict";

import React from "react";
import { findDOMNode } from "react-dom";
import classNames from "classnames/bind";
import {
  IconEssentials,
  IconParentSurvey,
  IconReconSurvey,
  IconBelSurvey,
} from "./icons.js";
import { OverallGraphicRep } from "./rep_graphics.js";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getElementData } from "./data_helpers.js";

export let links = getElementData("#links");
export let user = links._user; // TODO: probably doesn't belong here!
let activePage = links._page;

// TODO: re-use wherever *_template is used directly
export const getObjectLink = (d) =>
  d._level === "essentials"
    ? links.essential_template.replace("_PLACEHOLDER_", d.slug)
    : links.measure_template.replace("_PLACEHOLDER_", d.slug);

let Link = ({ page, newTab = false, className = "", children }) =>
  page in links ? (
    <a
      href={links[page]}
      className={classNames(className, { active: page === activePage })}
      target={newTab ? "_blank" : null}
    >
      {children}
    </a>
  ) : null;

let IconLink = ({ icon, label, className = "", children, ...props }) => (
  <Link className={classNames("icon-link", className)} {...props}>
    {icon}
    <br />
    {children}
  </Link>
);

let ReportLinks = ({ className, notesCount, includeLanding = false }) => (
  <div {...{ className }}>
    {includeLanding ? <Link page="report_intro">Report Home</Link> : null}
    <Link page="measure_notes">
      Measure Notes <span className="notes-count">({notesCount})</span>
    </Link>
    <Link page="measure_analysis">Measure Analysis</Link>
    <Link page="summary">Dashboard Summary</Link>
    <Link page="downloads">Downloads</Link>
    <Link page="about_report">About</Link>
    <Link page="invite_others">Invite Others</Link>
  </div>
);

// NOTE/HACK: `overall` parameter is used as a signal for context, i.e. intro versus other pages
export let Nav = ({ survey, target, overall, essentials, notesCount }) => (
  <nav className="nav">
    <div className="grid">
      <div className="nav-block entity">
        {overall ? (
          <OverallGraphicRep
            size={40}
            labels={false}
            survey={survey}
            essentials={essentials}
          />
        ) : null}
        <Link page="target_landing" className="home">
          <h1>
            {target.is_group ? "Group: " : null}
            {target.name}
          </h1>
          {overall ? <br /> : <h3>{target.type_description}</h3>}
          {target.is_group ? null : overall ? (
            <h3 className="organized-label">
              Overall:{" "}
              <span
                className={
                  "organized-text rank-" + overall._results.latest.code
                }
              >
                {overall._results.latest.rank.overall_long_label}
              </span>
            </h3>
          ) : (
            <h3>{target.full_address}</h3>
          )}
        </Link>
      </div>
      {target.is_group || !overall ? null : (
        <div className="nav-block">
          <OverlayTrigger
            trigger="click"
            placement="right"
            overlay={
              <Popover id="target-info" title={target.name}>
                <div className="school-type-label">
                  {target.type_description}
                </div>
                <div className="school-address">{target.full_address}</div>
              </Popover>
            }
          >
            <span className="glyphicon glyphicon-info-sign" />
          </OverlayTrigger>
        </div>
      )}
      <div className="nav-block survey-tabs">
        <IconLink page="report_intro" icon={<IconEssentials />}>
          {survey.labels.product_name} Survey
        </IconLink>
        <IconLink page="parent_survey" icon={<IconParentSurvey />}>
          Parent Survey
        </IconLink>
        <IconLink page="recon_survey" icon={<IconReconSurvey />}>
          Recon Survey
        </IconLink>
      </div>
      <div className="nav-block survey-subnav">
        <ReportLinks className="report-toolbar" notesCount={notesCount} />
      </div>
    </div>
  </nav>
);

export class MobileNav extends React.PureComponent {
  state = {};

  componentDidMount() {
    // HACK: mark the .desktop-header and fill in the .mobile-header with some of its content

    let desktopHeader = document.querySelector("header:not(.mobile-header)");
    desktopHeader.classList.add("desktop-header");

    let root = findDOMNode(this),
      logo = desktopHeader.querySelector("a.logo"),
      userStuff = desktopHeader.querySelector(
        ".global-links .text-link:last-child",
      );
    root.querySelector(".logo-wrapper").appendChild(logo.cloneNode(true));

    let userWrapper = root.querySelector(".user-wrapper");
    Array.from(userStuff.childNodes).forEach((origNode) => {
      userWrapper.appendChild(origNode.cloneNode(true));
    });
  }

  render() {
    let { notesCount } = this.props;
    let { isOpen } = this.state;

    return (
      <header className="mobile-header">
        <a
          className="nav-toggle nav-open"
          onClick={(evt) => {
            this.setState({ isOpen: true });
          }}
        >
          <span className="glyphicon glyphicon-menu-hamburger" />
        </a>
        <div className="logo-wrapper" />
        <div className="user-wrapper" />
        <div className={classNames("nav-panel", { isOpen })}>
          <a
            className="nav-toggle nav-close"
            onClick={(evt) => {
              this.setState({ isOpen: false });
            }}
          >
            <span className="glyphicon glyphicon-arrow-left" />
          </a>
          <div className="contents">
            <ReportLinks notesCount={notesCount} includeLanding={true} />
            <hr />
            <a href={links.help_url}>Support Center</a>
            {links.user_home ? (
              <a href={links.user_home}>User Homepage</a>
            ) : null}
          </div>
        </div>
      </header>
    );
  }
}

export let BelNav = ({ survey, target }) => (
  <nav className="nav">
    <div className="grid">
      <div className="nav-block entity">
        <Link page="target_landing" className="home">
          <h1>{target.name}</h1>
          <h3>{target.type_description}</h3>
          <h3>{target.full_address}</h3>
        </Link>
      </div>
      <div className="nav-block survey-tabs">
        <IconLink page="target_landing" icon={<IconBelSurvey />}>
          {survey.labels.product_name} Survey
        </IconLink>
      </div>
    </div>
  </nav>
);

export let BelNavAux = (_) => (
  <div className="bel-aux-nav">
    <div className="extra-links">
      <Link page="downloads">Downloads</Link>
      <span className="spacer" />
      <Link page="about_report">About</Link>
      <span className="spacer" />
      <Link page="invite_others">Invite Others</Link>
      <span className="spacer" />
      <Link page="appendix" newTab>
        Learning Beliefs Appendix
      </Link>
    </div>
  </div>
);
